import React, { useState ,useEffect,useRef} from 'react';
import { useNavigate } from 'react-router-dom';  // Correct import for useNavigate
import Button from 'react-bootstrap/Button';
import Modal from "react-modal";

Modal.setAppElement("#root"); 

const Registration = () => {
  const [email, setEmail] = useState('');
  const [fullname, setFullname] = useState('');
  const [phone, setPhone] = useState('');
  const [investType, setInvestType] = useState('');
  const [investExp, setInvestExp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');  // For displaying error messages
  const navigate = useNavigate();  // Replacing useHistory with useNavigate
  const [passwordError, setPasswordError] = useState('');
  const [eulaAccepted, setEulaAccepted] = useState(false);
  const [showEulaModal, setShowEulaModal] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [canAccept, setCanAccept] = useState(false);
  const scrollRef = useRef(null);

    useEffect(() => {
    fetch("/assets/eula.html")
      .then(res => res.text())
      .then(data => setHtmlContent(data))
      .catch(err => console.error("Error loading EULA:", err));
  }, []);

    const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        setCanAccept(true);
      }
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

 

        // Front-end password match validation
        if (password !== confirmPassword) {
          setPasswordError('Passwords do not match.');
          return;
        } else {
          setPasswordError('');
        }

             // EULA check
            if (!eulaAccepted) {
          setErrorMessage('You must accept the End User License Agreement.');
          return;
        }
        

    const data = {
      email,
      full_name: fullname,
      phone_number: phone.trim() !== '' ? phone : '',
      country_code: phone.trim() !== '' ? '+1' : '',
      invest_type: investType.trim() !== '' ? investType : '',
      invest_exp: investExp.trim() !== '' ? investExp : '',
      password: password.trim() !== '' ? password : '',
      eula_accepted: true,

    };

    try {
      const response = await fetch('https://beta.flowlogic.com/api/users/registration/', {
      // const response = await fetch('http://192.168.10.167:8000/api/users/registration/', {
        // const response = await fetch('https://flowlogic.uvjtech.in/api/users/registration/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      const result = await response.json();
      console.log('Response data:', result);
      
      if (response.ok) {
        // Registration successful, proceed to OTP
        localStorage.setItem('email', email);  // Store email for later use
        localStorage.setItem('otp', result.data.otp); 
        // navigate('/otp');  // Navigate to OTP page
        navigate('/');  // Navigate to OTP page

      } else {
        // If the response is not OK, show an error message
        if (Array.isArray(result.errors)) {
          console.log("array");
          setErrorMessage( result.errors.filter((error) => error.trim() !== '').join(', ') || 'Unknown error occurred.');
        } else if (typeof result.errors === 'string') {
          console.log("string");
          setErrorMessage( result.errors || 'Unknown error occurred.');
        }else{
          
           setErrorMessage(result.error || 'Registration failed. Please try again.');
        }
       
      }
    } catch (error) {
      console.error('Error during registration:', error);
      setErrorMessage('An error occurred during registration. Please try again.');
    }
  };

  return (
    <div className="register-container">
      <div className="logo"><img src={"/assets/Flowlogic-Logo.svg"} alt="FlowLogic Icon" /></div>
      <h4>Register</h4>

      {/* Display error message if any */}
      {passwordError && <div className="error-message" style={{ color: 'red' }}>{passwordError}</div>}
      {errorMessage && <div className="error-message" style={{ color: 'red' }}>{errorMessage}</div>}


      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="fullname">Full Name:</label>
          <input
            type="text"
            id="fullname"
            value={fullname}
            onChange={(e) => setFullname(e.target.value)}
            placeholder="Enter Full Name"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone Number:</label>
          <input
            type="text"
            // type="tel"
            id="phone"
            value={phone}
            // onChange={(e) => setPhone(e.target.value)}
            onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
            placeholder="Enter Phone Number"
            maxLength={10}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter Password"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm Password:</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm Password"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="investType">Investment Profile:</label>
          <select
            id="investType"
            value={investType}
            onChange={(e) => setInvestType(e.target.value)}
            placeholder="Select Investment Type"
            className="form-control" // Add any class for styling, e.g., form-control if you're using Bootstrap
          >
            <option value="">Select Investment Type</option>
            <option value="individual">Individual</option>
            <option value="re_agent">Real Estate Agent</option>
            <option value="analyst">Analyst</option>
            <option value="inv_firm">Investment Firm</option>
            <option value="prop_manager">Property Manager</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="investExp">Investment Experience:</label>
          <select
            id="investExp"
            value={investExp}
            onChange={(e) => setInvestExp(e.target.value)}
            placeholder="Select Investment Experience"
            className="form-control" // Same styling class
          >
            <option value="">Select Investment Experience</option>
            <option value="new">New</option>
            <option value="below3">Below 3 years</option>
            <option value="below5">Below 5 years</option>
            <option value="above5">Above 5 years</option>
          </select>
        </div>
        <div className="form-group"  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
          <div className="eula-checkbox" >
          <input
            type="checkbox"
            checked={eulaAccepted}
            onChange={(e) => {
              if (!e.target.checked) {
                // If trying to uncheck, allow it directly
                setEulaAccepted(false);
              } else {
                // If trying to check, show modal first
                setShowEulaModal(true);
              }
            }}
          />
          </div>
           <div className="eula-text">
          {' '}
          I have read and agree to the{' '}
          <span
            style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => setShowEulaModal(true)}
          >
            End User License Agreement
          </span>
          </div>
        </label>
      </div>



        <button type="submit" className="btn btn-success">Register</button>
      </form>

      {/* Modal */}

      {/* <Modal
        isOpen={showEulaModal}
        onRequestClose={() => setShowEulaModal(false)}
        contentLabel="EULA"
        style={{
          content: {
            width: "80%",
            maxWidth: "900px",
            height: "80vh",
            margin: "auto",
            padding:  0,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
      <div
          style={{
            padding: "10px",
            background: "#f5f5f5",
            borderBottom: "1px solid #ccc",
            flexShrink: 0,
          }}
        >
          <h3 style={{ margin: 0 }}>Flowlogic End User License Agreement</h3>
        </div>
        <div
          style={{
             width: "100%",
              height: "100%",
              border: "none",
          }}
        >
          <iframe
            src="/assets/pdf/FlowlogicEULA.pdf"
            title="EULA PDF"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        </div>
        <div style={{ marginTop: "20px", textAlign: "right" }}>
          <button onClick={() => setShowEulaModal(false)}>Cancel</button>{" "}
          <button
            className="btn btn-primary"
            onClick={() => {
              setEulaAccepted(true);
              setShowEulaModal(false);
              setErrorMessage("");
            }}
          >
            Agree
          </button>
        </div>
      </Modal> */}


      {/* EULA Modal */}
      <Modal
        isOpen={showEulaModal}
        onRequestClose={() => setShowEulaModal(false)}
        contentLabel="EULA"
        style={{
          content: {
            width: "80%",
            maxWidth: "900px",
            height: "80vh",
            margin: "auto",
            padding: 0,
            display: "flex",
            flexDirection: "column",
            position: "relative"
          },
        }}
      >
        {/* Header with Close button */}
        <div style={{
          padding: "10px",
          background: "#f5f5f5",
          borderBottom: "1px solid #ccc",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <h3 style={{ margin: 0 }}>Flowlogic End User License Agreement</h3>
          <button
              onClick={() => {
                setShowEulaModal(false);
                setCanAccept(false);   // reset so Agree won’t show immediately
              }}
            style={{ background: "transparent", border: "none", fontSize: "20px", cursor: "pointer" }}
          >
            ✕
          </button>
        </div>

        {/* Scrollable HTML Content */}
        <div
          ref={scrollRef}
          onScroll={handleScroll}
          style={{ flex: 1, overflowY: "auto", padding: "15px" }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />

        {/* Footer */}
        {/* <div style={{ padding: "10px", textAlign: "right", borderTop: "1px solid #ccc" }}>
          <button
            className="btn btn-primary"
            disabled={!canAccept}
            onClick={() => {
              setEulaAccepted(true);
              setShowEulaModal(false);
              setErrorMessage("");
            }}
          >
            Agree
          </button>
        </div> */}

 {canAccept && (
    <div
      style={{
        padding: "20px",
        textAlign: "right",
        borderTop: "1px solid #ccc",
      }}
    >
      <button
        // className="btn btn-primary"
        className="btn btn-flow"
        onClick={() => {
          setEulaAccepted(true);
          setShowEulaModal(false);
          setErrorMessage("");
        }}
      >
       I Agree
      </button>
    </div>
  )}

      </Modal>
      
       {/* Show error message */}
       {/* {error && <p style={{ color: 'red' }}>{error}</p>} */}
      <div className="SignInLink">Already have an account? <a href='/'>Sign In</a></div>
    </div>
  );
};

export default Registration;
